import { HotelCategory as component } from './component'
import { setCategory } from './reducer'
import { connect } from 'react-redux'

const mapDispatchToProps = dispatch => {
  return {
    topWaypointLeaveHandler: id => dispatch(setCategory(id)),
    bottomWaypointLeaveHandler: id => dispatch(setCategory(id))
  }
}

const container = connect(
  undefined,
  mapDispatchToProps
)(component)

export { container as HotelCategory }
